import React from "react";

function Section4() {
  return (
    <section className="csrd-section-4-container">
      <div className="csrd-section-4-inner-container">
        <div className="left-section-4">
          <div className="left-section-4-inner-container">
            <img
              src={require("../../../../assets/Solution/csrd/csrd_dashboard.svg")}
              className="img4"
              alt="dashboard"
            />
          </div>
        </div>
        <div className="right-section-4">
          <div className="right-section-4-inner-container">
            <div className="dot-grid-4"></div>
            <h2 className="section-4-heading">CSRD Dashboard</h2>
            <p className="section-4-description">
              <div>
                Live monitoring of CSRD disclosure completeness and real-time validation alerts.
              </div>
              <div>
                Visual analytics to track material ESG risks and their impact on compliance.
              </div>
              <div>Industry-specific benchmarking to assess sustainability performance.</div>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section4;
